<template>
  <div>
    <v-menu
      v-for="([text, rounded], index) in btns"
      :key="text"
      :rounded="rounded"
      offset-y
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          small
          elevation="0"
          light
          :class="textColorClass"
          :color="menuColor"
          class="ml-1 text-capitalize"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            left
            dark
          >
            local_taxi
          </v-icon>
          {{ text }}
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/book')"
        >
          <v-list-item-title v-text="'Create Booking'" />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
        >
          <v-list-item-title
            @click="goto('/bookings')"
            v-text="'Bookings'"
          />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
        >
          <v-list-item-title v-text="'Out Of Area'" />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
          @click="goto('/repeat_service')"
        >
          <v-list-item-title v-text="'Repeat'" />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
        >
          <v-list-item-title
            @click="goto('/backdate', true)"
            v-text="'Backdate'"
          />
        </v-list-item>
        <v-list-item
          class="py-0 my-0 list-item-height"
          dense
          link
        >
          <v-list-item-title
            @click="goto('/planner/timeline', true)"
            v-text="'Calendar'"
          />
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "BookingNavigation",
  data: () => ({
    btns: [
      ['Bookings', '0'],
    ],
    colors: ['deep-purple accent-4', 'error', 'teal darken-1'],
    items: [
        'Out of Area'
    ],
    menuRoutes: [
      'bookings', 'book', 'repeat_service', 'calendar', 'backdate', 'booking-details', 'view_driver', 'drivers_timeline'
    ],
  }),
  computed: {
    isRouteInMenu () {
      return this.menuRoutes.includes(this.$route.name)
    },
    menuColor () {
      if (this.isRouteInMenu) {
        return 'deep-purple accent-4'
      }
      return ''
    },
    textColorClass () {
      if (this.isRouteInMenu) {
        return 'white--text'
      }
      return ''
    }
  },
  methods: {
    goto (route, isNewTab = false) {
      if (isNewTab) {
        return window.open(route)
      }
      return this.$router.push(route)
    }
  }
}
</script>

<style scoped>

.list-item-height {
  min-height: 28px !important;
}

</style>